import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './i18n';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
